import { PropsWithChildren, forwardRef, memo } from 'react';

import clsx from 'clsx';

import { Attribution } from '../Attribution';
import {
  UseMapControllerOptions,
  useMapController
} from '../hooks/useMapController';

import styles from './styles.module.css';

type MapViewProps = PropsWithChildren<
  UseMapControllerOptions & {
    classes?: {
      root?: string;
    };
    tabIndex?: number;
  }
>;

export function MapView({
  children,
  classes,
  tabIndex = 0,
  ...controllerOptions
}: MapViewProps) {
  const { containerRef, onKeyDown } = useMapController(controllerOptions);

  return (
    <div className={clsx(styles.mapViewContainer, classes?.root)}>
      <div
        ref={containerRef}
        className={styles.mapView}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
      />
      {children}
      <Attribution />
    </div>
  );
}
